import { useState } from "react";
import { iStyle } from "../ui";
import { sigtePlatformApiFetch } from "./sigtePlatformUtils";
import logoSigte from "./assets/sigte-logo.png";

var BRAND = "#0F2C70";

export function SigtePlatformLogin(p) {
  var [u,setU]=useState("");
  var [pw,setPw]=useState("");
  var [err,setErr]=useState("");
  var [busy,setBusy]=useState(false);

  function go() {
    setErr(""); setBusy(true);
    sigtePlatformApiFetch("/login", {method:"POST", body:JSON.stringify({username:u,password:pw})})
      .then(function(r){return r.json();})
      .then(function(d){
        if(d.error){setErr(d.error);setBusy(false);}
        else{p.onLogin(Object.assign({}, d.admin, {token: d.token}));}
      })
      .catch(function(){setErr("Error de conexion. Intenta de nuevo.");setBusy(false);});
  }

  return (
    <div style={{minHeight:"100vh",background:"linear-gradient(160deg,#0F2C70,#1a3d8f 60%,#0a1f52)",display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{width:"100%",maxWidth:380}}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <img src={logoSigte} alt="SIGTE" style={{width:200,height:"auto",aspectRatio:"1942/809"}}/>
          <p style={{color:"rgba(255,255,255,0.5)",fontSize:13,marginTop:5,fontStyle:"italic"}}>Panel de plataforma</p>
        </div>
        <div style={{background:"rgba(255,255,255,0.08)",borderRadius:16,padding:28,border:"1px solid rgba(255,255,255,0.15)"}}>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:11,color:"rgba(255,255,255,0.6)",display:"block",marginBottom:5,fontWeight:600,textTransform:"uppercase"}}>Usuario</label>
            <input value={u} onChange={function(e){setU(e.target.value);}} onKeyDown={function(e){if(e.key==="Enter")go();}} placeholder="Tu usuario" style={Object.assign({},iStyle,{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",color:"#fff"})}/>
          </div>
          <div style={{marginBottom:20}}>
            <label style={{fontSize:11,color:"rgba(255,255,255,0.6)",display:"block",marginBottom:5,fontWeight:600,textTransform:"uppercase"}}>Contrasena</label>
            <input type="password" value={pw} onChange={function(e){setPw(e.target.value);}} onKeyDown={function(e){if(e.key==="Enter")go();}} placeholder="Contrasena" style={Object.assign({},iStyle,{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",color:"#fff"})}/>
          </div>
          {err?<div style={{background:"rgba(220,38,38,0.2)",border:"1px solid rgba(220,38,38,0.4)",borderRadius:8,padding:"10px 14px",fontSize:13,color:"#fca5a5",marginBottom:14}}>{err}</div>:null}
          <button onClick={go} disabled={busy} style={{width:"100%",padding:"12px 0",borderRadius:10,border:"none",background:"rgba(255,255,255,0.95)",color:BRAND,fontWeight:800,fontSize:14,cursor:"pointer",opacity:busy?0.7:1}}>{busy?"Verificando...":"Iniciar sesion"}</button>
        </div>
      </div>
    </div>
  );
}
